import "react-app-polyfill/stable";

import React from "react";
import ReactDOM from "react-dom";
import { unstable_HistoryRouter as Router } from "react-router-dom";

import reportWebVitals from "./utils/reportWebVitals";
import App from "./App";
import { customHistory } from "./utils/history";

ReactDOM.render(
  <Router history={customHistory}>
    <React.StrictMode>
      <App />
    </React.StrictMode>
  </Router>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
